import { render } from "./ExtendExpiredAtModal.vue?vue&type=template&id=899fdae0"
import script from "./ExtendExpiredAtModal.vue?vue&type=script&lang=js"
export * from "./ExtendExpiredAtModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__